module.exports = __webpack_public_path__ + "img/3-5.fcd546b3.svg";